
  import {
    mapSectionComponents,
    replaceActivityDataInSections,
  } from '@/helper/SectionHelper';
  import {getMetaTags, replaceActivityDataInMetaData} from '@/helper/Seo';
  import LazyHydrate from 'vue-lazy-hydration';
  import {scopeHelper} from '@/helper/ScopeHelper';

  export default {
    name: 'LandingPageActivitiesActivity',
    components: {
      LazyHydrate,
    },
    async asyncData({app, route, error, $cachedStrapi}) {
      const pagePromise = $cachedStrapi
        .findOne('pages', 'landingpages-activities-activity')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const activityPromise = $cachedStrapi
        .findOne('activities', route.params.activity)
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });

      const [page, activity] = await Promise.all([
        pagePromise,
        activityPromise,
      ]);

      if (!scopeHelper(page, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Page not found'});
        return;
      }
      if (!scopeHelper(activity, process.env.SCOPE_CANDIDATE)) {
        error({statusCode: 404, message: 'Activity not found'});
        return;
      }

      // Map section components and replace city data/placeholder
      let sections = await mapSectionComponents(
        page.sections,
        async function (section) {
          switch (section.component) {
            case 'SectionBreadcrumbs':
              section.breadcrumbs = [
                {
                  text: app.i18n.t('page.index'),
                  disabled: false,
                  to: app.localePath({
                    name: 'index',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: app.i18n.t('page.landingpage_activities'),
                  disabled: false,
                  to: app.localePath({
                    name: 'landingpages-activities',
                  }),
                  nuxt: true,
                  exact: true,
                },
                {
                  text: activity.title,
                  disabled: true,
                  to: app.localePath({
                    name: 'landingpages-activities-activity',
                    params: {
                      activity: activity.slug,
                    },
                  }),
                  nuxt: true,
                  exact: true,
                },
              ];
              break;

            case 'SectionSeoContent':
              if (
                activity.seo_content_config &&
                activity.seo_content_config.seo_contents &&
                activity.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  activity.seo_content_config.seo_contents[0].id
                );
              } else if (
                section.seo_content_config &&
                section.seo_content_config.seo_contents &&
                section.seo_content_config.seo_contents[0]
              ) {
                section.seoContent = await $cachedStrapi.findOne(
                  'seo-contents',
                  section.seo_content_config.seo_contents[0].id
                );
              }
              break;
          }
        }
      );
      sections = replaceActivityDataInSections(sections, activity);

      const metaData = replaceActivityDataInMetaData(page.meta ?? {}, activity);

      return {
        metaData,
        sections,
        activity,
      };
    },
    data() {
      return {
        metaData: {},
        sections: [],
        activity: {},
      };
    },
    head() {
      return {
        title: this.metaData.title,
        meta: getMetaTags(this.metaData),
      };
    },
  };
